import { Component, OnInit } from '@angular/core';
import { paginationParams } from '@shared/config/table.config';
import { columnDefs } from './skills.config';
import { ErrorMessages } from '@constants/constants';
import { SearchService } from '@services/search.service';
import { PersonaType } from '@constants/global.enum';
import { Router } from '@angular/router';
import { EmployeeSkills, EmployeeSkillsResponse } from '@app/shared/interfaces/employee-skiils';
import { SkillsService } from './skills.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-skills',
  templateUrl: './skills.component.html',
  styleUrl: './skills.component.scss',
})
export class SkillsComponent implements OnInit {
  displayData: EmployeeSkills[] = [];
  paginationParams = paginationParams;
  columnDefs = columnDefs;
  filterValue: string = '';
  imageSrc: string = 'assets/img/no-data-found.png';
  errorMsg: string = ErrorMessages.NoDataAvailable;
  isDataLoaded: boolean = true;
  fieldsVisibility: string = PersonaType.SkillsView;
  opened: boolean = false;

  originalData: EmployeeSkills[] = [];

  constructor(private searchService: SearchService, private router: Router,private skillsService: SkillsService, private toasterService: ToastrService) {}

  ngOnInit() {
    this.getEmployeeSkills();
  }

  getEmployeeSkills(){
    const userProfile = sessionStorage.getItem('userProfile');
    const employeeId = userProfile ? JSON.parse(userProfile)?.employeeId : '';
    this.skillsService.getEmployeeSkills(employeeId).subscribe({
      next:(res: EmployeeSkillsResponse)=>{
        this.displayData = res?.data ?? [];
        this.originalData = res?.data ?? [];
        },
      error: (err) => {
        this.toasterService.error(ErrorMessages.NoDataAvailable);
      }
    });
  }

  searchContractors(event: KeyboardEvent) {
    this.filterValue = this.searchService.getFilteredValue(
        event as KeyboardEvent,
    );
    this.displayData = this.originalData?.length
        ? this.searchService.getSearchedData(
            this.originalData,
            this.filterValue?.toLowerCase(),
        )
        : [];
  }

  clearInput() {
    this.filterValue = '';
    this.displayData = [...this.originalData];
  }

  onFilterApplied(skills: any) {
    this.displayData = skills.data;
    this.opened = skills.buttonClick === 'reset';
  }

  navigateToContractorProfile(contractorId: number): void {
    this.router.navigate([`/vendor-management/contractor-profile/${contractorId}`]);
  }
}
